import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flex: 1,
        marginTop: 82
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
    },

    subTitle: {
        fontSize: 28,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        marginTop: 64
    },

    subSubTitle: {
        fontSize: 18,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        marginTop: 24
    },

    organigram: {
        marginTop: 32,
    },

    leader: {
        marginTop: 32,
        borderWidth: 1,
        borderRadius: 24,
        borderColor: 'white'
    },

    text: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 18,
    },

    table: {
    },

    tableHeader: {
        backgroundColor: '#535353',
        height: 52,
        paddingLeft: 10,
        justifyContent: 'center',
        marginTop: 32,
        borderWidth: 1,
        borderColor: 'white',
        borderTopRightRadius: 24,
        borderTopLeftRadius: 24
    },

    tableTitle: {
        fontSize: 16,
        color: '#FFC646',
        fontFamily: 'Montserrat',
        fontWeight: '600'
    },

    row: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },

    arrayKey: {
        fontSize: 14,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '600',
        flex: 1
    },

    arrayValue: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        flex: 1
    },

    borderView: {
        flex: 1,
        paddingLeft: 12,
        borderColor: '#535353',
        borderWidth: 1,
        paddingVertical: 10                
    },

    leadersContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
    },

    leadersContainerMobile: {
        flexDirection: 'column',
    },

    leaderElement: {
        flex: 1,
        marginRight: 25
    },

    leaderElementMobile: {
        alignItems: 'center',
        marginBottom: 25
    },

    logo: {
       height: 150,
       width: 200,
       alignSelf: 'flex-start',
       alignItems: 'flex-start'
    }
});